import React, { useState } from 'react';
import './MovieCard.css';

interface MovieCardProps {
  title: string;
  imageUrl: string;
  rating: number;
  year: number;
  description?: string;
  trailerUrl?: string;
}

const MovieCard: React.FC<MovieCardProps> = ({ 
  title, 
  imageUrl, 
  rating, 
  year, 
  description = "No description available for this title.", 
  trailerUrl = "https://www.youtube.com/embed/dQw4w9WgXcQ" // Default trailer
}) => {
  const [showInfoPopup, setShowInfoPopup] = useState(false);
  const [showTrailerPopup, setShowTrailerPopup] = useState(false);

  const handleInfoClick = () => {
    setShowInfoPopup(true);
  };

  const handlePlayClick = () => {
    setShowTrailerPopup(true);
  };

  const closePopups = () => {
    setShowInfoPopup(false);
    setShowTrailerPopup(false);
  };

  return (
    <>
      <div className="movie-card">
        <div className="movie-poster">
          <img src={imageUrl} alt={title} />
          <div className="movie-overlay">
            <button className="btn btn-primary play-btn" onClick={handlePlayClick}>▶ Play</button>
            <button className="btn btn-secondary info-btn" onClick={handleInfoClick}>ℹ Info</button>
          </div>
        </div>
        <div className="movie-info">
          <h3 className="movie-title">{title}</h3>
          <div className="movie-meta">
            <span className="movie-year">{year}</span>
            <span className="movie-rating">⭐ {rating}/10</span>
          </div>
        </div>
      </div>

      {/* Info Popup */}
      {showInfoPopup && (
        <div className="popup-overlay" onClick={closePopups}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <div className="popup-header">
              <h2>{title} ({year})</h2>
              <button className="close-btn" onClick={closePopups}>×</button>
            </div>
            <div className="popup-body">
              <div className="popup-info">
                <img src={imageUrl} alt={title} className="popup-poster" />
                <div className="popup-details">
                  <p className="popup-rating">Rating: ⭐ {rating}/10</p>
                  <p className="popup-description">{description}</p>
                </div>
              </div>
            </div>
            <div className="popup-footer">
              <button className="btn btn-primary" onClick={handlePlayClick}>Watch Trailer</button>
            </div>
          </div>
        </div>
      )}

      {/* Trailer Popup */}
      {showTrailerPopup && (
        <div className="popup-overlay" onClick={closePopups}>
          <div className="popup-content video-popup" onClick={(e) => e.stopPropagation()}>
            <div className="popup-header">
              <h2>{title} - Trailer</h2>
              <button className="close-btn" onClick={closePopups}>×</button>
            </div>
            <div className="popup-body">
              <div className="video-container">
                <iframe 
                  src={trailerUrl} 
                  title={`${title} Trailer`}
                  frameBorder="0" 
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MovieCard; 